import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ThreatGroupTooltipsStyled,
  ThreatGroupTooltipsDescription,
  ThreatGroupTooltipsBullet,
  ThreatGroupTooltipsBullets,
} from '../ThreatGroupTooltip.styled'

export const InvalidMalicious = () => {
  const { t } = useTranslation('botMitigation')
  return (
    <ThreatGroupTooltipsStyled>
      <ThreatGroupTooltipsDescription>
        {t('threatGroups.tooltips.invalidMalicious.description')}
      </ThreatGroupTooltipsDescription>
      <ThreatGroupTooltipsBullets>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidMalicious.false_representation')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidMalicious.disabled_cookies')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidMalicious.click_hijacking')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidMalicious.disabled_js')}
        </ThreatGroupTooltipsBullet>
        <ThreatGroupTooltipsBullet>
          {t('threatGroups.tooltips.invalidMalicious.excessive_rate_limit')}
        </ThreatGroupTooltipsBullet>
      </ThreatGroupTooltipsBullets>
    </ThreatGroupTooltipsStyled>
  )
}
